import { FormikProps } from 'formik';
import React from 'react';
import Field from '@cpg-its/ads.form.field';
import { makeStyles } from '@material-ui/core';
import { ParseNumberFormat } from '../../helpers/clipboard-helper';

const numberInputStyles = makeStyles((theme) => ({
	currencyInput: {
		'& .MuiInputBase-root': {

			'& input': {
				paddingLeft: theme.spacing(1),
			},
			'&:before': {
				position: 'absolute',
				content: '"$"',
				display: 'block',
				marginLeft: theme.spacing(.5),

			},
		},

	},
	percentageInput: {
		'& .MuiInputBase-root': {
			'& input': {
				paddingRight: theme.spacing(1),
			},
			'&:after': {
				position: 'absolute',
				content: '"%"',
				display: 'block',
				right: '0',
				marginRight: theme.spacing(1.5),

			},
		},

	},
	autoWidth: {
		'& .MuiInputBase-root': {
			width: '10rem',
		},
	},
}));

export enum NumberInputTypes {
	Currency,
	Percentage,
	Integer,
	Float,
	PercentageInteger,
}

interface Props {
	name: string;
	label: string;
	required?: boolean;
	autoWidth?: boolean;
	type: NumberInputTypes,
	formikProps: FormikProps<any>;
	tooltip?: string;
	onBlur?: (e) => any;
	onChange?: (e) => any;
	disabled?: boolean;
	testId?: string;
}
export function NumberField(props: Props) {
	const { name, label, formikProps, onBlur, onChange, type, required, tooltip, disabled, testId } = props;
	const inputClasses = numberInputStyles();
	const getForcedValue = (value) => {
		let newValue: number | string;

		if (type === NumberInputTypes.Currency || type === NumberInputTypes.Percentage || type === NumberInputTypes.Float) {
			newValue = value ? parseFloat(value).toFixed(2) : '0.00';
		} else if (type === NumberInputTypes.Integer || type === NumberInputTypes.PercentageInteger) {
			newValue = value ? Math.trunc(value) : 0;
		} else {
			newValue = value;
		}

		return newValue;
	};

	const handleBlur = (e) => {
		const { value } = e.target;

		formikProps.setFieldTouched(name, true);

		formikProps.setFieldValue(name, getForcedValue(value));

		onBlur(e);
	};

	const handleChange = (e) => {
		let fieldValue = e?.target?.value;

		if (fieldValue === '.'){
			fieldValue = '0.';			
		}

		if (fieldValue === '-'){
			fieldValue = '-0';			
		}

		formikProps.setFieldValue(name, fieldValue);			
		onChange(e);
	};

	const handlePaste = (e) => {
		const parsedvalue = ParseNumberFormat(e.clipboardData.getData('text'));
		formikProps.setFieldValue(name, parsedvalue);		
	};

	const handleKeyPress = (e) => {				

		const fieldValue = e?.target?.value;

		if ( e.key === 'Backspace' ||
			e.key === 'Delete' ||
			e.key === 'ArrowRight' ||
			e.key === 'ArrowLeft') return;

		if (fieldValue && e.key === '-' && fieldValue?.indexOf('-') !== -1) {			
			e.preventDefault();			
		}

		if (fieldValue && e.key === '.' && fieldValue?.indexOf('.') !== -1) {			
			e.preventDefault();			
		}

		if (!e.altKey && !e.ctrlKey && !e.metaKey &&
			!e.key.match(/^[0-9.-]+$/)){
			e.preventDefault();
		}
	};
	
	return (
		<div className={`form-item ${(type === NumberInputTypes.Currency ? inputClasses.currencyInput : '')} ${((type === NumberInputTypes.Percentage || type === NumberInputTypes.PercentageInteger) ? inputClasses.percentageInput : '')}`}>
			<div className={props.autoWidth ? inputClasses.autoWidth : ''}>
				<Field
					name={name}
					label={label}
					component='input'													
					required={required}
					onBlur={handleBlur}
					onChange={handleChange}
					tooltip={tooltip != null ? { title: tooltip } : null}
					disabled={disabled}
					onPaste={handlePaste}
					onKeyPress={handleKeyPress}
					testId={testId}
				/>
			</div>
		</div>
	);
}

NumberField.defaultProps = {
	onBlur: () => { },
	onChange: () => { },
	required: false,
	autoWidth: false,
	tooltip: null,
	disabled: false,
	testId : '',
};